import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { isDemoModeAtom } from '../../../generatorState'

export const FACEBOOK_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: '#80A3C1',
	clone1: '#D2A388',
})

export const facebookPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? FACEBOOK_DEMO_PRIMARY_COLOR : get(primaryColorAtom),
)

export const facebookSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? 'white' : get(secondaryColorAtom),
)
